var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.999 0Q115.461 0 97.73-17.538 80-35.076 80-59.998q0-24.538 17.73-42.269 17.731-17.73 42.269-17.73h680.002q24.538 0 42.269 17.538Q880-84.921 880-59.999q0 24.538-17.73 42.269Q844.539 0 820.001 0H139.999ZM240-303.46h49.461l332.002-331.386-25.154-25.539-24.923-24.538L240-352.921v49.461Zm-59.999 23.845v-83.767q0-7.231 2.423-13.77 2.424-6.538 8.039-12.153l437.923-436.924q8.692-8.692 19.73-13.153 11.039-4.462 22.808-4.462 12.153 0 23.114 4.462 10.962 4.461 20.269 13.769l48.077 48.692q9.307 8.692 13.461 19.845 4.154 11.154 4.154 23.307 0 11.154-4.154 22.192t-13.461 20.346L325.46-254.308q-5.615 5.615-12.153 8.231-6.539 2.615-13.77 2.615h-83.382q-15.461 0-25.807-10.346-10.347-10.346-10.347-25.807Zm540.384-454.769-49.461-49.461 49.461 49.461Zm-98.922 99.538-25.154-25.539-24.923-24.538 50.077 50.077Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostEdit);
export default __webpack_public_path__ + "static/media/postEdit.1910d77d4b77746d975e974248bca4e3.svg";
export { ForwardRef as ReactComponent };